/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TacticalMeetingProjectsView_role$ref: FragmentReference;
declare export opaque type TacticalMeetingProjectsView_role$fragmentType: TacticalMeetingProjectsView_role$ref;
export type TacticalMeetingProjectsView_role = {|
  +databaseId: string,
  +organization: {|
    +databaseId: string
  |},
  +$refType: TacticalMeetingProjectsView_role$ref,
|};
export type TacticalMeetingProjectsView_role$data = TacticalMeetingProjectsView_role;
export type TacticalMeetingProjectsView_role$key = {
  +$data?: TacticalMeetingProjectsView_role$data,
  +$fragmentRefs: TacticalMeetingProjectsView_role$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TacticalMeetingProjectsView_role",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Role",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '3040a0aef1203fdb017cb24a3cc23ce3';

module.exports = node;
